import { Box, Flex, Switch, Text } from "@chakra-ui/react";
import { LockIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import type { ExclusionGroundsCriterionDto } from "../../../../../autogen/bff-api";

interface Props {
  criterion: ExclusionGroundsCriterionDto;
  isActive: boolean;
  onToggle: (id: string, active: boolean) => void;
}

export const ExclusionGroundItem = ({ criterion, isActive, onToggle }: Props) => {
  const { i18n } = useTranslation();
  const isNorwegian = i18n.language === "no";
  const name = (isNorwegian ? criterion.nameNorwegian : null) ?? criterion.name;
  const description = (isNorwegian ? criterion.descriptionNorwegian : null) ?? criterion.description;

  return (
    <Flex justify="space-between" align="center" py="3" px="4" borderBottomWidth="1px" borderColor="smBorder">
      <Box flex="1" mr="4">
        <Text fontSize="sm" fontWeight="medium" color={criterion.mandatory ? "smMuted" : "smText"}>
          {name}
        </Text>
        <Text fontSize="xs" color="smMuted" mt="0.5">
          {description}
        </Text>
      </Box>
      {criterion.mandatory ? (
        <Flex align="center" gap="2">
          <LockIcon boxSize="3" color="smMuted" data-testid="exclusion-ground-lock" />
        </Flex>
      ) : (
        <Switch
          isChecked={isActive}
          onChange={() => onToggle(criterion.id, !isActive)}
          aria-label={name}
        />
      )}
    </Flex>
  );
};
